import { render, staticRenderFns } from "./MenuSubmenu.vue?vue&type=template&id=6cb80468&"
import script from "./MenuSubmenu.vue?vue&type=script&lang=js&"
export * from "./MenuSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports